import { Select, SelectProps } from "antd";

/**
 * Select do modal de proposta: dropdown no body com z-index acima do Modal.
 */
export default function PropostaSelect<
  ValueType = string,
  OptionType extends { value?: string | number; label?: React.ReactNode } = {
    value: string;
    label: React.ReactNode;
  },
>(props: SelectProps<ValueType, OptionType>) {
  const { popupClassName, getPopupContainer, ...rest } = props;

  return (
    <Select<ValueType, OptionType>
      {...rest}
      popupClassName={["proposta-modal-dropdown--light", popupClassName]
        .filter(Boolean)
        .join(" ")}
      getPopupContainer={getPopupContainer || (() => document.body)}
      dropdownStyle={{ zIndex: 11050 }}
    />
  );
}
